<template>
  <router-view></router-view>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: var(--main-color-2)
}

nav a.router-link-exact-active {

  color: var(--main-color)
}
</style>

<script>
export default {
  name: 'app'
}
</script>